import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4691c5bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "rightlistBox"
};
const _hoisted_2 = {
  class: "rs4"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "ui label"
}, "热门文章", -1));
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "ui label"
}, "用户交流", -1));
const _hoisted_6 = {
  class: "r1-head"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "欢迎关注我们的团队公众号AI小助手，咨询项目源码等相关内容。", -1));
const _hoisted_8 = ["src"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "r1-body"
}, null, -1));
const _hoisted_10 = ["src"];
import image_scroll from '../../../assets/scroll.png';
import { onMounted, ref, onUnmounted } from "vue";
import { useScroll } from "@vueuse/core";
export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleRight',
  props: {
    browseList: {
      type: Array,
      default: () => []
    }
  },
  setup(__props) {
    const isMobile = ref(false);
    const {
      y
    } = useScroll(window);
    const toTopFun = () => {
      let timer = setInterval(function () {
        //获取滚动条距离顶部高度
        const osTop = document.documentElement.scrollTop || document.body.scrollTop;
        const iSpeed = Math.floor(-osTop / 7);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + iSpeed;
        //到达顶部，清除定时器
        if (osTop == 0) {
          clearInterval(timer);
          timer = null;
        }
      }, 30);
    };
    const props = __props;
    // // 创建伪造的数据
    // const browseList = ref([
    //   {id: 1, title: 'Vue 3 Composition API 使用指南', viewCount: 1200},
    //   {id: 2, title: '理解 Vue 3 响应式系统', viewCount: 850},
    //   {id: 3, title: '如何在 Vue 3 中使用 TypeScript', viewCount: 920},
    //   {id: 4, title: 'Vue 3 组件间通信最佳实践', viewCount: 710},
    //   {id: 5, title: '从 Vue 2 迁移到 Vue 3 的步骤', viewCount: 650}
    // ])
    const checkIfMobile = () => {
      isMobile.value = window.innerWidth <= 768; // 根据需要调整判断条件
    };
    onMounted(() => {
      checkIfMobile();
      window.addEventListener('resize', checkIfMobile);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', checkIfMobile);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.browseList, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: 'browseList' + index
        }, [_createElementVNode("a", {
          href: '/article/detail/' + item.id,
          target: "_blank"
        }, _toDisplayString(item.title), 9, _hoisted_4), _createTextVNode(" —— " + _toDisplayString(item.count) + " 次围观 ", 1)]);
      }), 128))])]), _createElementVNode("section", null, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("img", {
        style: {
          "width": "200px",
          "height": "200px"
        },
        src: require('../../../assets/ai-niuzhanAccount.jpg'),
        alt: ""
      }, null, 8, _hoisted_8)]), _hoisted_9]), !isMobile.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(y) > 600 ? 'toTop hidden' : 'toTop goTop hidden'),
        onClick: toTopFun
      }, [_createElementVNode("img", {
        src: _unref(image_scroll),
        alt: ""
      }, null, 8, _hoisted_10)], 2)) : _createCommentVNode("", true)]);
    };
  }
});